<template lang="html">
  <div class="fullScreen manager">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content">
        <div class="box">
          <div class="row search">
            <div class="col-sm-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-4 col-form-label">账号：</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control"  placeholder="" v-model="account">
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-4 col-form-label">姓名：</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control"  placeholder="" v-model="realname">
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-4 col-form-label">状态：</label>
                <div class="col-sm-8">
                  <select id="inputState" class="form-control" v-model="status">
                    <option value=""></option>
                    <option value="1">正常</option>
                    <option value="2">已封禁</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group row no-gutters">
                <label for="staticEmail" class="col-sm-4 col-form-label">类型：</label>
                <div class="col-sm-8">
                  <select id="inputState" class="form-control" v-model="type">
                    <option value=""></option>
                    <option value="1">总管理</option>
                    <option value="2">协会管理</option>
                    <option value="3">普通</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="ml-md-auto" style="margin: 0 auto;">
              <div class="btn btn-primary" @click="search">
                搜索
              </div>
              <div class="btn btn-info" @click="download">
                导出结果
              </div>
            </div>
          </div>
          <div class="row table-content">
            <p v-if="!list.length" class="no-result">{{role==2?'对不起，您没有操作权限':'无结果'}}</p>
            <div role="region" aria-labelledby="caption" tabindex="0" class="col-sm-12" style="overflow: auto;background-color:#fff;">
              <table class="table"  v-if="list.length">
                <thead class="">
                  <tr scope="row" class="text-center">
                    <th scope="col">ID</th>
                    <th scope="col">登录账号</th>
                    <th scope="col">真实姓名</th>
                    <th scope="col">账号类型</th>
                    <th scope="col">注册时间</th>
                    <th scope="col">最后登录时间</th>
                    <th scope="col">状态</th>
                    <th scope="col">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center" v-for="item in list">
                    <th scope="row">{{item.id}}</th>
                    <td>{{item.mobile}}</td>
                    <td>{{item.realname}}</td>
                    <td>{{item.role}}</td>
                    <td>{{item.regtime}}</td>
                    <td>{{item.lastlogin}}</td>
                    <td>{{item.status}}</td>
                    <td><a href data-toggle="modal" data-target="#checkBox" @click="changeCurrentId(item.id,item.status)">{{item.status=='正常'?'封禁':'解封'}}</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <page-ctrl v-bind:totalPage="totalPage" v-bind:currentPage="currentPage" v-on:catchPage="catchPage"></page-ctrl>
          </div>
        </div>
      </div>
    </div>
    <!-- model -->
    <div class="modal fade" id="checkBox" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            是否{{currentState == "正常"?'封禁':'解封'}}？
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-primary" @click="banned">确认</button>
          </div>
        </div>
      </div>
    </div>
    <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose" v-bind:msg="tips"></alert-model>

  </div>
</template>

<script>
import alertModel from './alert.vue'
import commonHeader from './header.vue'
import pageCtrl from './pagination.vue'
export default {
  data() {
    return {
      list: [],
      currentId: '',
      currentState: '',
      totalPage: '',
      currentPage: '',
      realname: '',
      account: '',
      status: '',
      type: '',
      role: '',
      alertShow: false,
      tips: '',
      alertFunc: ''
    }
  },
  methods: {
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    download() {
      window.location.href = 'http://app.shiminjia.com/api/wenlian/dlacc'
    },
    changeCurrentId(id, state) {
      this.currentId = id
      this.currentState = state
    },
    catchPage(data) {
      console.log(data.p)
      let p = data.p
      let params = {
        realname: this.realname,
        mobile: this.account,
        status: this.status,
        role: this.type
      }
      this.$axios.post(`/api/wenlian/accountlist?page=${p}`, this.qs.stringify(params)).then(res => {
        this.list = res.data.data
        this.totalPage = res.data.sumpage
        this.currentPage = res.data.curpage
      })
    },
    banned() {
      let params = {
        id: this.currentId
      }
      if (this.currentState == "正常") {
        this.$axios.post('/api/wenlian/accountban', this.qs.stringify(params)).then(res => {
          if (res.data.result == 1) {
            this.alert(res.data.msg, () => {
              window.location.reload()
            })
          } else {
            this.alert(res.data.msg)
          }
        })
      } else {
        this.$axios.post('/api/wenlian/accountunban', this.qs.stringify(params)).then(res => {
          if (res.data.result == 1) {
            this.alert(res.data.msg, () => {
              window.location.reload()
            })
          } else {
            this.alert(res.data.msg)
          }
        })
      }
    },
    search() {
      let params = {
        realname: this.realname,
        mobile: this.account,
        status: this.status,
        role: this.type
      }
      this.$axios.post('/api/wenlian/accountlist?page=1', this.qs.stringify(params)).then(res => {
        if (res.data.result == 1) {
          this.list = res.data.data
          this.totalPage = res.data.sumpage
          this.currentPage = res.data.curpage
        }
      })
    }
  },
  components: {
    commonHeader,
    pageCtrl,
    alertModel
  },
  mounted() {
    this.role = this.$store.state.user.role
    this.$axios.get('/api/wenlian/accountlist?page=1').then(res => {
      if (res.data.result == 1) {
        this.list = res.data.data
        this.totalPage = res.data.sumpage
        this.currentPage = res.data.curpage
      }
      // else {
      //   this.list = [{ "id": "1", "mobile": "18678997531", "realname": "caiguoqian", "role": "\u666e\u901a", "regtime": "2019-04-03 17:07", "status": "\u6b63\u5e38" }, { "id": "5", "mobile": "adminadmin", "realname": "\u7ba1\u7406\u5458", "role": "\u603b\u7ba1\u7406", "regtime": "2019-04-10 11:25", "status": "\u6b63\u5e38" }, { "id": "6", "mobile": "15563929558", "realname": "\u4e8e\u654f", "role": "\u666e\u901a", "regtime": "2019-04-15 18:17", "status": "\u6b63\u5e38" }, { "id": "7", "mobile": "18669776011", "realname": "\u9a6c\u6770", "role": "\u603b\u7ba1\u7406", "regtime": "2019-04-16 09:34", "status": "\u6b63\u5e38" }, { "id": "8", "mobile": "13953220362", "realname": "\u8bb8\u4e1c\u56fd", "role": "\u666e\u901a", "regtime": "2019-04-16 11:33", "status": "\u6b63\u5e38" }, { "id": "10", "mobile": "18953278956", "realname": "\u674e\u6770", "role": "\u666e\u901a", "regtime": "2019-05-09 11:30", "status": "\u6b63\u5e38" }, { "id": "11", "mobile": "13645422636", "realname": "\u6d4b\u8bd5", "role": "\u666e\u901a", "regtime": "2019-06-05 17:51", "status": "\u6b63\u5e38" }, { "id": "12", "mobile": "13808997601", "realname": "\u5f90\u4f50", "role": "\u666e\u901a", "regtime": "2019-12-11 20:10", "status": "\u6b63\u5e38" }, { "id": "13", "mobile": "13969786515", "realname": "\u4e01\u4f1a\u5143", "role": "\u666e\u901a", "regtime": "2020-01-28 15:43", "status": "\u6b63\u5e38" }, { "id": "14", "mobile": "18106331938", "realname": "\u738b\u6d69", "role": "\u666e\u901a", "regtime": "2020-01-29 01:43", "status": "\u6b63\u5e38" }, { "id": "15", "mobile": "13210803969", "realname": "\u9648\u6587\u56fd", "role": "\u666e\u901a", "regtime": "2020-02-26 11:05", "status": "\u6b63\u5e38" }, { "id": "16", "mobile": "17806399706", "realname": "\u4f55\u8fce\u521a", "role": "\u666e\u901a", "regtime": "2020-03-15 20:43", "status": "\u6b63\u5e38" }, { "id": "17", "mobile": "18561698973", "realname": "\u738b\u6668", "role": "\u666e\u901a", "regtime": "2020-03-17 20:16", "status": "\u6b63\u5e38" }, { "id": "18", "mobile": "15192796238", "realname": "\u674e\u6615\u6167", "role": "\u666e\u901a", "regtime": "2020-03-24 10:15", "status": "\u6b63\u5e38" }, { "id": "19", "mobile": "13906420974", "realname": "\u4e8e\u7acb\u65b0", "role": "\u666e\u901a", "regtime": "2020-04-29 17:46", "status": "\u6b63\u5e38" }, { "id": "20", "mobile": "17685869605", "realname": "\u738b\u4e30", "role": "\u666e\u901a", "regtime": "2020-05-26 15:32", "status": "\u6b63\u5e38" }, { "id": "21", "mobile": "15063923920", "realname": "\u4faf\u8302\u901a", "role": "\u666e\u901a", "regtime": "2020-06-15 22:23", "status": "\u6b63\u5e38" }, { "id": "22", "mobile": "15906394898", "realname": "\u82cf\u5b66\u4ead", "role": "\u666e\u901a", "regtime": "2020-06-18 07:56", "status": "\u6b63\u5e38" }, { "id": "23", "mobile": "15194279372", "realname": "\u675c\u91d1\u9716", "role": "\u666e\u901a", "regtime": "2020-08-12 20:06", "status": "\u6b63\u5e38" }, { "id": "24", "mobile": "15092039316", "realname": "\u738b\u5fd7\u5f3a", "role": "\u666e\u901a", "regtime": "2020-08-19 13:50", "status": "\u6b63\u5e38" }]
      // }
    })
  }
}
</script>

<style lang="css" scoped>
.manager .ibox-title .btn {
  padding-left: 40px;
  padding-right: 40px;
}
.manager.fullScreen {
  height: 100%;
}
.manager .table {
  border: 1px solid #33434b;
}
.manager .table tbody tr:nth-child(2n) {
  background: #fff;
}
.manager .table tbody tr:nth-child(2n-1) {
  background: #f9f9f9;
}
.manager .state1 {
  color: red;
}
.manager .state2 {
  color: #333;
}
.manager .state3 {
  color: green;
}
.manager td > a {
  margin: 0 10px;
}
.manager thead {
  background: #fff;
  color: #33434b;
}
.manager tbody,
.page-link {
  color: #33434b;
}
.manager .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}
.manager .page-link.active {
  background: #f4f4f4;
}
.manager .table thead th {
  vertical-align: middle;
}
.manager .search {
  width: 100%;
  padding: 20px;
  border: 1px solid #a9afb5;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 20px;
}
.manager .line {
  font-size: 18px;
  color: #333;
  text-align: center;
  line-height: 2;
}
.manager .form-group label {
  font-size: 15px;
  color: #33434b;
}
.manager input,
.manager select,
.manager .textarea,
.manager .form-check label {
  color: #33434b;
  font-size: 15px;
}
.manager .ml-md-auto .btn {
  width: 100px;
  margin-right: 15px;
}
.manager .form-check label {
  line-height: 3;
}
@media screen and (max-width: 750px) {
  .modal-footer > :not(:first-child) {
    margin-left: auto;
  }
  .table-content {
    margin: 0;
  }
  .table {
    width: 1000px;
    table-layout: fixed;
    border: none !important;
    border-collapse: separate;
    border-spacing: 0;
  }
  .table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 25vw;
    /* box-shadow: 0 0 0.8em rgba(0, 0, 0, 0.5); */
    background: white;
  }
  .table thead th:first-child {
    position: sticky;
    left: 0;
    z-index: 10;
    border-left: 1px solid #a9afb5;
    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
    /* box-shadow: 0 0 0.8em rgba(0, 0, 0, 0.5); */
  }
  .table tbody th {
    position: sticky;
    left: 0;
    background: white;
    z-index: 9;
    border-left: 1px solid #a9afb5;
    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
  }
  [role="region"][aria-labelledby][tabindex] {
    width: 450px;
    height: 400px;
    overflow: auto;
    padding: 0;
    outline: 0;
  }
}
/*.manager .btn-primary:not(:disabled):not(.disabled).active,.manager .btn-primary:not(:disabled):not(.disabled):active,.manager .show>.btn-primary.dropdown-toggle{opacity: 0.5;background-color: #18a689;border-color: #18a689;}
.manager .btn-primary{background-color: #18a689;border-color: #18a689;width: 200px;}
.manager .btn-primary:hover{background-color: #1ab394;border-color: #1ab394;}
.manager .btn-primary.disabled{opacity: 0.5;background-color: #18a689;border-color: #18a689;}*/
</style>



// WEBPACK FOOTER //
// src/components/management.vue